/**
 * Éléments HTML
 */
const sectionTitleElements = document.querySelectorAll(".section__title");
const bodyEl = document.querySelector("body");
const contentEl = document.querySelector(".content");
const artistsEl = document.querySelector("#artistes");
const artistsListEl = document.querySelector(".artists__list");
const artistsListItemEl = document.querySelectorAll(".artists__list__item");
const contactEl = document.querySelector("#contact");
const pictosEl = document.querySelectorAll(".services__list__picto");
const parallaxEls = document.querySelectorAll(".parallax");

/**
 * Valeurs numériques, constantes...
 */
const offset = 200;
const artistsTriggerTop = artistsEl.offsetTop + 500;
const artistsTriggerBottom = artistsTriggerTop + artistsEl.offsetHeight + 200;
const contactTriggerTop = contactEl.offsetTop;

/**
 * Décalage horizontal du bloc artistes
 * au scroll vertical
 */
function updateArtistsHorizontalScroll(scrollValue) {
  artistsListItemEl.forEach((el) => {
		const left = scrollValue - el.offsetLeft;
    const offsetValue = -0.1 * left;
    el.style.setProperty("--offset-value", `${offsetValue}px`);
    el.style.setProperty("--scroll-value", `-${scrollValue}px`);
    el.parentElement.style.setProperty("--scroll-value", `-${scrollValue}px`);
  });
}

function handleScroll(scrollPosition) {
  horizontalScroll = scrollPosition - artistsTriggerTop;

  if (scrollPosition >= artistsTriggerBottom) {
    updateArtistsHorizontalScroll(horizontalScroll);
  } else if (scrollPosition >= artistsTriggerTop) {
    updateArtistsHorizontalScroll(horizontalScroll);
  }

  if (scrollPosition >= contactTriggerTop) {
    bodyEl.classList.add("scaled");
  } else {
    bodyEl.classList.remove("scaled");
  }
  parallaxEls.forEach((parallaxEl) => {
    const top = parallaxEl.offsetTop;
    const offsetValue = -0.2 * (scrollPosition - top);
    parallaxEl.style.setProperty("--offset-value", `${offsetValue}px`);
  });
}

/**
 * Listeners
 */
let lastKnownScrollPosition = 0;
let horizontalScroll = 0;
let ticking = false;

window.addEventListener("scroll", (event) => {
  lastKnownScrollPosition = window.scrollY;
  if (ticking) {
    window.requestAnimationFrame(function () {
      handleScroll(lastKnownScrollPosition);
      ticking = false;
    });
  }

  ticking = true;
});
/**
 * Changement de couleur du body
 */

/**
 * Changement de couleur du fond
 */
function updateBackground(color) {
  if (!color) return;
  bodyEl.style.setProperty("--background", `var(--${color})`);
}

const observerOptions = {
  root: null,
  rootMargin: "0px",
  threshold: [0, 0.25, 0.5, 0.75, 1],
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    const parentSection = entry.target.closest(".section");
    const { background } = parentSection.dataset;

    if (entry.intersectionRatio > 0.5) {
      updateBackground(background);
    }
  });
}, observerOptions);

sectionTitleElements.forEach((section) => observer.observe(section));

const pictoObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    const lottieInstance = entry.target
      .querySelector("lottie-player")
      .getLottie();
    // lottieInstance.loop = true
    lottieInstance.playCount = 2;

    if (entry.intersectionRatio === 1) {
      lottieInstance.play();
    }
  });
}, observerOptions);

pictosEl.forEach((picto) => {
  pictoObserver.observe(picto);
});
